import { combineReducers } from 'redux';
import data from './data';
import auth from './authReducer';
import filter from './filter';
import view from './view';
import db from './db';

export default combineReducers({
  data,
  filter,
  auth,
  view,
  db
});
